(() => {
  'use strict';
  if (window.__sdPolicyExperience) return;
  window.__sdPolicyExperience = true;

  const messages = {
    'shipping-policy': ['Shipping, without the fog', 'Shipping methods, costs, and timing are explained below. Checkout shows the options available for your order and destination.'],
    'refund-policy': ['Returns, made easier', 'Eligibility, timing, exceptions, and return instructions are explained below using the store policy as the source of truth.'],
    'privacy-policy': ['Privacy, in human language', 'This page explains what information may be collected, why it is used, who helps process it, and the choices available to you.'],
    'terms-of-service': ['The rules of the road', 'These terms cover shopping, payments, shipping, returns, site use, and the legal framework behind ShadowsDeal.'],
    'contact-information': ['Need a hand?', 'Questions about an order, product, return, or store policy are welcome. Include your order number when it applies.']
  };

  function boot() {
    if (!/^\/policies\//.test(location.pathname)) return;
    const container = document.querySelector('.shopify-policy__container');
    if (!container || container.querySelector('.sd-policy-intro')) return;

    const slug = location.pathname.split('/').filter(Boolean).pop() || '';
    const copy = messages[slug] || ['Store policy', 'The important details, organized to be easier to scan.'];
    const intro = document.createElement('aside');
    intro.className = 'sd-policy-intro';
    intro.innerHTML = `<span>SHADOWSDEAL POLICY DESK</span><h2>${copy[0]}</h2><p>${copy[1]}</p>`;

    const title = container.querySelector('.shopify-policy__title');
    if (title) title.insertAdjacentElement('afterend', intro);
    else container.prepend(intro);

    document.body.classList.add('sd-policy-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
